import { render, staticRenderFns } from "./SidebarTree.vue?vue&type=template&id=3f8ccc39&scoped=true&"
import script from "./SidebarTree.vue?vue&type=script&lang=js&"
export * from "./SidebarTree.vue?vue&type=script&lang=js&"
import style0 from "./SidebarTree.vue?vue&type=style&index=0&id=3f8ccc39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8ccc39",
  null
  
)

export default component.exports